import { useCallback, useMemo, useState } from "react";
import { useDatasourceOptions } from "./useDatasourceOptions";

type Choice = { conversationId: string | null; keys: string[] };

export function useDatasourceSelection(conversationId: string | null, savedKeys: string[] | null) {
  const options = useDatasourceOptions();
  const [choice, setChoice] = useState<Choice | null>(null);

  const allowed = useMemo(() => options.map((o) => o.key), [options]);

  const selected = useMemo(() => {
    const source = choice && choice.conversationId === conversationId ? choice.keys : savedKeys ?? [];
    const valid = allowed.filter((key) => source.includes(key));
    return valid.length ? valid : allowed;
  }, [allowed, choice, conversationId, savedKeys]);

  const toggle = useCallback(
    (key: string) => {
      const next = selected.includes(key)
        ? selected.filter((k) => k !== key)
        : allowed.filter((k) => k === key || selected.includes(k));
      if (next.length === 0) return;
      setChoice({ conversationId, keys: next });
    },
    [allowed, conversationId, selected],
  );

  return { options, selected, toggle };
}
